import React from 'react';
import styled from 'styled-components';
import { Trans } from '@lingui/react';
import { t } from '@lingui/macro';
import RightArrowIcon from '@assets/ArrowRightIcon';
import VideoCameraIcon from '@assets/VideoCameraIcon';
import IconTooltip from '@components/IconTooltip';
import { LinkToRecording } from '@gql/generated';
import { LiveEvent } from '@gql/generated';
import AnalyticsManager from '@lib/analytics/manager';

const Element = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid #e0e0e0;
  border-radius: 5px;
  padding: 20px 15px;
  margin: -5px 0 10px 0;

  :before {
    content: '';
    position: absolute;
    left: -2px;
    top: -1px;
    bottom: -1px;
    width: 5px;
    border-radius: 4px;
    background-color: #56b9e5;
  }

  @media (min-width: ${({ theme }) => theme.viewports.mobile}px) {
    flex-direction: row-reverse;
    padding-left: 30px;
    padding-right: 30px;
    margin-left: 30px;
  }
`;

const RecordingLink = styled.a`
  flex: 1;
  display: flex;
  align-items: center;
  text-decoration: none;
  margin-right: 10px;

  svg {
    height: 14px;
  }
`;

const Text = styled.span`
  display: inline-block;
  font-size: 13px;
  margin: 0 6px;
`;

const RecodingText = styled(Text)`
  font-size: 14px;
  color: #56b9e5;
  font-weight: bold;
`;

const TooltipWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 5px;

  @media (min-width: ${({ theme }) => theme.viewports.mobile}px) {
    margin-bottom: 0;
  }
`;

type Props = {
  event: LiveEvent;
  recording: LinkToRecording;
};

const EventRecordingRow = ({ event, recording }: Props) => {
  const onClick = () => {
    AnalyticsManager().sendClickedLiveRecordingEvent({
      name: event.title,
      amount: event.price?.originalPrice,
      type: event.theme,
      instructor: event.primaryInstructor?.name,
    });
  };

  return (
    <Element>
      <TooltipWrapper>
        <Text>
          <Trans id="live.event_page.recording_more_info" />
        </Text>
        <IconTooltip
          translationId={t`live.event_page.recording_more_info_tooltip`}
        />
      </TooltipWrapper>
      <RecordingLink
        href={recording.link}
        target="_blank"
        rel="noopener"
        onClick={onClick}
      >
        <VideoCameraIcon />
        <RecodingText>
          <Trans id="live.event_page.watch_session_recording" />
        </RecodingText>
        <RightArrowIcon />
      </RecordingLink>
    </Element>
  );
};

export default EventRecordingRow;
